import React from 'react';
import { CardContainer } from './styles';

const Card = ({ card, onClick, sourceColumnId }) => {
  const handleDragStart = (e) => {
    e.dataTransfer.setData('text', card.id);
    e.dataTransfer.setData('sourceColumnId', sourceColumnId);
  };
  
  return (
    <CardContainer onClick={onClick} style={{ whiteSpace: 'pre-wrap' }}>
      {/* draggable onDragStart={handleDragStart} */}
      {card.TituloCard}
    </CardContainer>
  );
};

export default Card;
